import { buildSort, goPromise } from "@delanobgt/admin-core/util/helpers";
import {
  ApiClientFactory,
  IMeta,
  IPagination,
  ISort,
} from "@delanobgt/admin-core/util/types";
import { CancelTokenSource } from "axios";
import _ from "lodash";

import {
  EPackageCouponEffectSortField,
  IPackageCouponEffect,
  PPackageCouponEffect,
  PPackageCouponEffectFilter,
} from "../entities";
import IPackageCouponEffectRepository from "../repository";

export default class PackageCouponEffectRepository
  implements IPackageCouponEffectRepository<CancelTokenSource> {
  private apiClientFactory: ApiClientFactory;

  // api routes
  private GUIDE_DETAIL_TYPE_ROUTE = "/admin/package-coupon-effect";

  constructor(apiClientFactory: ApiClientFactory) {
    this.apiClientFactory = apiClientFactory;
  }

  buildFilter = (filter: PPackageCouponEffectFilter) => {
    return filter;
  };

  private getSignalToken(signal: CancelTokenSource) {
    return _.get(signal, "token", null);
  }

  private getError(error: any) {
    return _.get(error, "response.data.errors", "Something went wrong.");
  }

  async getPackageCouponEffect(
    pagination: IPagination,
    filter: PPackageCouponEffectFilter,
    sorts: ISort<EPackageCouponEffectSortField>[],
    signal?: CancelTokenSource
  ): Promise<[IPackageCouponEffect[], IMeta]> {
    const sort = buildSort(sorts);
    const params = _.pickBy(
      {
        ...pagination,
        ...this.buildFilter(filter),
      },
      Boolean
    );
    const [err, response] = await goPromise(
      this.apiClientFactory({ cancelToken: this.getSignalToken(signal) }).get(
        `${this.GUIDE_DETAIL_TYPE_ROUTE}?sort=${sort}`,
        {
          params,
        }
      )
    );
    if (err) {
      throw this.getError(err);
    }
    const { data, meta } = response.data;
    return [data, meta];
  }

  async getPackageCouponEffectById(id: number): Promise<IPackageCouponEffect> {
    const [err, response] = await goPromise(
      this.apiClientFactory().get(`${this.GUIDE_DETAIL_TYPE_ROUTE}/${id}`)
    );
    if (err) {
      throw this.getError(err);
    }
    return response.data;
  }

  async createPackageCouponEffect(
    packageCouponEffect: PPackageCouponEffect
  ): Promise<void> {
    const [err] = await goPromise(
      this.apiClientFactory().post(
        this.GUIDE_DETAIL_TYPE_ROUTE,
        packageCouponEffect
      )
    );
    if (err) {
      throw this.getError(err);
    }
  }

  async updatePackageCouponEffect(
    id: number,
    packageCouponEffect: PPackageCouponEffect
  ): Promise<void> {
    const [err] = await goPromise(
      this.apiClientFactory().patch(
        `${this.GUIDE_DETAIL_TYPE_ROUTE}/${id}`,
        packageCouponEffect
      )
    );
    if (err) {
      throw this.getError(err);
    }
  }
}
